import styles from "./DetailsIBO.module.css";
import { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { ContactView } from "shared/components/ContactView/ContactView";
import { VCSDisplay } from "shared/components/VCSDisplay/VCSDisplay";

/**
 * Displays detailed info for the selected customer contact.
 */
export function DetailsIBO({ id, linkBase }) {
  const { t } = useTranslation();

  const { isLoading, isError, data, error } = useQuery(`/ibos/${id}`);

  if (data == null || isLoading) {
    return t("labels.loading");
  }

  if (isError) {
    console.error(error);
    return "ERROR";
  }

  // console.log(data);

  return (
    <div className={styles.container}>
      <div className={styles.details}>
        <ContactView contact={data.ibo} />
      </div>

      {data.ibo.vcs.monthly.length > 0 ? (
        <div className={styles.vcs}>
          <VCSDisplay data={data.ibo.vcs} />
        </div>
      ) : (
        t("BSM.VCSDataAvailability")
      )}
    </div>
  );
}

DetailsIBO.propTypes = {
  id: PropTypes.number.isRequired,
  linkBase: PropTypes.string.isRequired,
};
